(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobsaver-x1-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jobsaver-x1')) {
  customElements.define('jobsaver-x1', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const listen = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: this.abort.signal });
      let config;
      try { config = JSON.parse(this.querySelector('[data-x1-config]').textContent); } catch { return; }
      const form = this.querySelector('form.x1-form');
      const master = this.querySelector('[data-master]');
      const options = [...this.querySelectorAll('[data-option]')];
      const add = this.querySelector('[data-add]');
      const status = this.querySelector('[data-status]');
      const range = this.querySelector('[data-savings-range]');
      const addon = this.querySelector('[data-addon]');
      const addonWrap = this.querySelector('[data-addon-wrap]');
      const addonTotal = this.querySelector('[data-addon-total]');
      let submitting = false;
      const totalMoney = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD' });
      const updateAddonTotal = () => {
        const hasUpgrade = Boolean(addon?.checked && !addon.disabled);
        const total = selected ? selected.price + (hasUpgrade ? Number(config.addonPrice || 0) : 0) : 0;
        const formattedTotal = selected ? totalMoney.format(total / 100) : '—';
        if (addonTotal) {
          addonTotal.hidden = !hasUpgrade || !selected;
          addonTotal.textContent = selected && hasUpgrade ? `Total with wheel pack: ${formattedTotal}` : '';
        }
        if (add && !submitting) {
          add.textContent = selected?.available ? `${config.strings.add} — ${formattedTotal}` : (selected ? config.strings.soldOut : config.strings.unavailable);
        }
      };
      if (addonWrap) addonWrap.hidden = false;
      listen(addon, 'change', updateAddonTotal);
      let selected = config.variants.find(v => String(v.id) === master?.value);
      let money;
      try { money = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD', maximumFractionDigits: 0 }); }
      catch { money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }); }
      const recalculate = () => {
        const monthly = Number(range.value);
        this.querySelector('[data-savings-label]').textContent = money.format(monthly);
        this.querySelector('[data-payback]').textContent = selected ? (selected.price / 100 / monthly).toLocaleString(config.locale || 'en', { maximumFractionDigits: 1, minimumFractionDigits: 1 }) : '—';
      };
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      let active = Math.max(0, slides.findIndex(s => !s.hidden));
      const activate = index => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          if (i !== active) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => { if (!slide.hidden) frame.src = frame.src; });
          }
          slide.hidden = i !== active;
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
        const thumb = thumbs[active];
        if (thumb) thumb.parentElement.scrollTo({ left: Math.max(0, thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'auto' });
      };
      thumbs.forEach((thumb, i) => listen(thumb, 'click', () => activate(i)));
      listen(this.querySelector('[data-prev]'), 'click', () => activate(active - 1));
      listen(this.querySelector('[data-next]'), 'click', () => activate(active + 1));
      listen(this.querySelector('[data-gallery]'), 'keydown', e => {
        if (!e.target.matches('[data-zoom],[data-prev],[data-next]')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); activate(active + (e.key === 'ArrowRight' ? 1 : -1)); slides[active].querySelector('[data-zoom]')?.focus(); }
      });
      const update = (fromOptions, updateUrl = true) => {
        selected = fromOptions && options.length ? config.variants.find(v => v.options.every((value, i) => value === options[i]?.value)) : config.variants.find(v => String(v.id) === master.value);
        if (!selected) {
          master.value = '';
          add.disabled = true;
          add.textContent = config.strings.unavailable;
          status.textContent = config.strings.unavailable;
          this.querySelectorAll('[data-price]').forEach(el => { el.textContent = '—'; });
          this.querySelector('[data-compare]').hidden = true;
        } else {
          master.value = String(selected.id);
          options.forEach((option, i) => { option.value = selected.options[i]; });
          this.querySelectorAll('[data-price]').forEach(el => { el.textContent = selected.formatted; });
          const compare = this.querySelector('[data-compare]');
          compare.hidden = !(selected.compare > selected.price);
          compare.textContent = selected.formattedCompare;
          add.disabled = !selected.available;
          add.textContent = selected.available ? `${config.strings.add} — ${selected.formatted}` : config.strings.soldOut;
          status.textContent = selected.available ? `${selected.options.join(' / ')} — ${selected.formatted}` : config.strings.soldOut;
          if (selected.mediaId) {
            const index = slides.findIndex(slide => slide.dataset.mediaId === String(selected.mediaId));
            if (index >= 0) activate(index);
          }
        }
        if (updateUrl) {
          const url = new URL(location.href);
          if (selected) url.searchParams.set('variant', String(selected.id)); else url.searchParams.delete('variant');
          history.replaceState(history.state, '', url);
        }
        master.dispatchEvent(new Event('change', { bubbles: true }));
        recalculate();
        updateAddonTotal();
      };
      options.forEach(option => listen(option, 'change', () => update(true)));
      if (master && form) {
        this.querySelector('[data-native-picker]').hidden = true;
        this.querySelector('[data-enhanced-picker]').hidden = false;
        update(false, false);
        listen(form, 'submit', async e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (submitting) return;
          status.removeAttribute('data-error');
          if (!selected?.available || master.value !== String(selected.id)) {
            status.setAttribute('data-error', '');
            status.textContent = config.strings.unavailable;
            return;
          }
          const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
          const items = [{ id: selected.id, quantity }];
          if (addon?.checked && !addon.disabled) items.push({ id: Number(addon.dataset.variantId), quantity });
          submitting = true;
          add.disabled = true;
          add.textContent = 'Adding…';
          status.textContent = 'Adding your selection to the cart…';
          form.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(config.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add your selection. Please try again.');
            status.textContent = 'Added to cart.';
            window.location.assign(config.cartUrl);
          } catch (error) {
            status.setAttribute('data-error', '');
            status.textContent = error.message || 'Unable to confirm the cart update. Please check your cart before trying again.';
          } finally {
            submitting = false;
            form.removeAttribute('aria-busy');
            add.disabled = !selected?.available;
            updateAddonTotal();
          }
        }, { capture: true });
        // Cart-drawer apps grab add-to-cart clicks and add only the machine, dropping the wheel pack.
        // Catch the click on window first so the submit handler above adds both items.
        listen(window, 'click', e => {
          const button = e.target.closest?.('[data-add]');
          if (!button || !form.contains(button)) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!button.disabled) form.requestSubmit(button);
        }, { capture: true });
      }
      listen(window, 'popstate', () => {
        const variantId = new URL(location.href).searchParams.get('variant');
        if (variantId && config.variants.some(v => String(v.id) === variantId)) { master.value = variantId; update(false, false); }
      });
      listen(range, 'input', recalculate);
      const dialog = this.querySelector('[data-lightbox]');
      const enlarged = this.querySelector('[data-lightbox-image]');
      this.querySelectorAll('[data-zoom]').forEach(button => listen(button, 'click', () => {
        enlarged.src = button.dataset.src;
        enlarged.alt = button.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      listen(this.querySelector('[data-close]'), 'click', () => dialog.close());
      listen(dialog, 'click', e => { if (e.target === dialog) { const rect = dialog.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close(); } });
      this.querySelectorAll('video').forEach(video => listen(video, 'play', () => this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
      const sticky = this.querySelector('[data-sticky]');
      const buy = this.querySelector('.x1-buybox');
      const refreshSticky = () => {
        this.frame = null;
        if (!sticky) return;
        sticky.hidden = buy.getBoundingClientRect().bottom >= 0 || this.getBoundingClientRect().bottom <= 90 || window.innerWidth > 749;
      };
      const scheduleSticky = () => { if (!this.frame) this.frame = requestAnimationFrame(refreshSticky); };
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky);
      refreshSticky();
      listen(this, 'click', e => {
        const link = e.target.closest('a[href^="#X1"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.querySelector('[data-lightbox]')?.close();
      this.initialized = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobsaver-x2-cro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jobsaver-x2-cro')) {
  customElements.define('jobsaver-x2-cro', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const configNode = this.querySelector('[data-x2-config]');
      let config;
      try {
        if (!configNode) throw new Error('pending');
        config = JSON.parse(configNode.textContent);
      } catch {
        if (!this.initializer) {
          this.initializer = new MutationObserver(() => this.connectedCallback());
          this.initializer.observe(this, { childList: true, subtree: true, characterData: true });
        }
        return;
      }
      this.initializer?.disconnect();
      this.initializer = null;
      this.config = config;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });
      const all = selector => [...this.querySelectorAll(selector)];
      const get = name => this.querySelector('[data-role="' + name + '"]');
      const c = this.config;
      const text = c.text;
      const master = this.querySelector('[data-variant-select]');
      const battery = this.querySelector('[data-battery]');
      const form = this.querySelector('form');
      const radios = all('[data-setup]');
      const firstOption = [...new Set(c.variants.map(v => v.options[0]))];
      const batteryOptions = [...new Set(c.variants.map(v => v.options[1]).filter(Boolean))];
      const standard = firstOption.find(value => /fine/i.test(value));
      const carbide = firstOption.find(value => /carbide/i.test(value));
      const enhanced = c.options.length === 2 && firstOption.length === 2 && standard && carbide && batteryOptions.length;
      const setupValues = { standard, carbide };
      const initial = c.variants.find(v => v.id === c.initialId);
      this.state = { setup: initial?.options[0] === carbide ? 'carbide' : 'standard', photo: 'selected', variant: initial || null };
      let price = c.price;
      const money = cents => new Intl.NumberFormat(c.locale || 'en', { style: 'currency', currency: c.currency }).format(cents / 100);
      const scrollTo = (node, focus = false) => {
        node?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        if (focus) node?.focus({ preventScroll: true });
      };
      const calc = () => {
        const recovery = get('recovery');
        if (!recovery) return;
        let spend = 0;
        all('[data-cost-row]').forEach(row => {
          const quantity = Math.max(0, Math.min(10000, Number(row.querySelector('[data-quantity]').value) || 0));
          const cost = Math.max(0, Math.min(100000, Number(row.querySelector('[data-cost]').value) || 0));
          spend += quantity * cost;
        });
        const share = Number(recovery.value);
        const saved = spend * share / 100;
        get('recovery-value').textContent = share + '%';
        get('monthly-saving').textContent = spend ? money(saved * 100) : '—';
        get('payback').textContent = saved > 0 ? (price / 100 / saved).toFixed(1) + ' ' + text.months : '—';
        get('calc-prompt').textContent = spend ? money(spend * 100) + ' ' + text.spend + ' × ' + share + '% ' + text.avoided : text.prompt;
      };
      const photo = key => {
        this.state.photo = key;
        const imageKey = key === 'selected' ? this.state.setup : key;
        const thumbnail = all('[data-photo]').find(button => button.dataset.photo === key);
        get('hero-image').src = thumbnail?.dataset.gallerySrc || c.images[imageKey];
        get('hero-image').alt = thumbnail?.dataset.galleryAlt || (key === 'selected' ? setupValues[this.state.setup] || c.variants[0]?.title : text[key]);
        get('photo-caption').textContent = get('hero-image').alt;
        all('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.photo === key)));
      };
      const update = (changeUrl = false) => {
        const variant = enhanced ? c.variants.find(v => v.options[0] === setupValues[this.state.setup] && v.options[1] === battery.value) : c.variants.find(v => String(v.id) === master.value);
        const displayed = variant || c.variants.find(v => v.options[0] === setupValues[this.state.setup]) || c.variants[0];
        this.state.variant = variant || null;
        price = displayed?.price ?? c.price;
        all('[data-price]').forEach(el => el.textContent = money(price));
        const compare = this.querySelector('[data-compare]');
        compare.hidden = !(displayed?.compare > price);
        compare.textContent = displayed?.compare ? money(displayed.compare) : '';
        const unavailable = enhanced && battery.value && !variant;
        get('add-button').disabled = Boolean(unavailable || (variant && !variant.available));
        get('add-button').textContent = unavailable ? text.unavailable : variant && !variant.available ? text.sold : text.add + ' — ' + money(price);
        get('selection-status').textContent = variant?.title || (setupValues[this.state.setup] || '') + ' · ' + (battery.value || text.choose);
        if (enhanced) {
          master.value = variant ? String(variant.id) : '';
          master.dispatchEvent(new Event('change', { bubbles: true }));
          get('selected-thumb').src = c.images[this.state.setup];
        }
        const terms = this.querySelector('shopify-payment-terms');
        if (variant && terms) terms.setAttribute('variant-id', String(variant.id));
        if (changeUrl && variant) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
        }
        calc();
      };
      const chooseSetup = (setup, shouldScroll) => {
        if (!enhanced) { scrollTo(get('buy')); return; }
        this.state.setup = setup;
        radios.forEach(radio => radio.checked = radio.value === setup);
        update(true);
        photo('selected');
        if (shouldScroll) { scrollTo(get('buy')); radios.find(r => r.value === setup)?.focus({ preventScroll: true }); }
      };
      if (enhanced) {
        this.querySelector('[data-enhanced-picker]').hidden = false;
        this.querySelector('[data-native-picker]').hidden = true;
        battery.required = true;
        battery.value = initial?.options[1] || '';
        radios.forEach(radio => {
          radio.checked = radio.value === this.state.setup;
          listen(radio, 'change', () => chooseSetup(radio.value, false));
        });
        listen(battery, 'change', () => update(true));
      } else {
        listen(master, 'change', () => update(true));
      }
      all('[data-select-setup]').forEach(button => listen(button, 'click', () => chooseSetup(button.dataset.selectSetup, true)));
      listen(form, 'submit', event => {
        update();
        if (!this.state.variant?.available || !form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          if (enhanced && !battery.value) battery.focus();
        }
      });
      all('[data-scroll]').forEach(link => listen(link, 'click', event => {
        const target = get(link.dataset.scroll);
        if (target) { event.preventDefault(); scrollTo(target, link.dataset.scroll === 'reviews'); }
      }));
      const badge = this.querySelector('[data-review-badge]');
      listen(badge, 'click', event => {
        event.preventDefault(); event.stopPropagation(); scrollTo(get('reviews'), true);
      }, { capture: true });
      listen(badge, 'keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault(); event.stopPropagation(); scrollTo(get('reviews'), true);
      }, { capture: true });
      all('[data-photo]').forEach(button => listen(button, 'click', () => photo(button.dataset.photo)));
      listen(get('zoom-button'), 'click', () => {
        get('zoom-image').src = get('hero-image').src;
        get('zoom-image').alt = get('hero-image').alt;
        get('image-modal').showModal();
      });
      all('[data-play]').forEach(button => listen(button, 'click', () => {
        const demo = c.demos[Number(button.dataset.play)], video = get('modal-video');
        all('video').forEach(v => v.pause());
        get('modal-video-title').textContent = demo.title;
        get('modal-video-description').textContent = demo.description || '';
        video.src = demo.src; video.poster = demo.poster;
        get('video-modal').showModal();
        video.play().catch(() => {});
      }));
      all('[data-close]').forEach(button => listen(button, 'click', () => button.closest('dialog').close()));
      all('dialog').forEach(dialog => {
        listen(dialog, 'close', () => dialog.querySelectorAll('video').forEach(video => video.pause()));
        listen(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        });
      });
      all('.calculator input').forEach(input => listen(input, 'input', calc));
      listen(get('example'), 'click', () => {
        const example = [[5,15],[4,10],[1,45],[0,50],[2,10]];
        all('[data-cost-row]').forEach((row,i) => {
          row.querySelector('[data-quantity]').value = example[i][0];
          row.querySelector('[data-cost]').value = example[i][1];
        });
        get('recovery').value = 50; calc();
      });
      listen(get('reset-calculator'), 'click', () => {
        all('.calc-table input').forEach(input => input.value = '');
        get('recovery').value = 50; calc();
      });
      const stickyCheck = () => get('sticky-buy').hidden = get('buy').getBoundingClientRect().bottom > 0;
      listen(window, 'scroll', stickyCheck, { passive: true });
      listen(window, 'resize', stickyCheck);
      update(); if (enhanced) photo('selected'); stickyCheck();
    }
    disconnectedCallback() {
      this.initializer?.disconnect();
      this.initializer = null;
      this.controller?.abort();
      this.controller = null;
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobsaver-x2-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jobsaver-x2-cro')) {
  customElements.define('jobsaver-x2-cro', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const configNode = this.querySelector('[data-x2-config]');
      let config;
      try {
        if (!configNode) throw new Error('pending');
        config = JSON.parse(configNode.textContent);
      } catch {
        if (!this.initializer) {
          this.initializer = new MutationObserver(() => this.connectedCallback());
          this.initializer.observe(this, { childList: true, subtree: true, characterData: true });
        }
        return;
      }
      this.initializer?.disconnect();
      this.initializer = null;
      this.config = config;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });
      const all = selector => [...this.querySelectorAll(selector)];
      const get = name => this.querySelector('[data-role="' + name + '"]');
      const c = this.config;
      const text = c.text;
      const master = this.querySelector('[data-variant-select]');
      const battery = this.querySelector('[data-battery]');
      const form = this.querySelector('form');
      const radios = all('[data-setup]');
      const firstOption = [...new Set(c.variants.map(v => v.options[0]))];
      const batteryOptions = [...new Set(c.variants.map(v => v.options[1]).filter(Boolean))];
      const standard = firstOption.find(value => /fine/i.test(value));
      const carbide = firstOption.find(value => /carbide/i.test(value));
      const enhanced = c.options.length === 2 && firstOption.length === 2 && standard && carbide && batteryOptions.length;
      const setupValues = { standard, carbide };
      const initial = c.variants.find(v => v.id === c.initialId);
      this.state = { setup: initial?.options[0] === carbide ? 'carbide' : 'standard', photo: 'selected', variant: initial || null };
      let price = c.price;
      const money = cents => new Intl.NumberFormat(c.locale || 'en', { style: 'currency', currency: c.currency }).format(cents / 100);
      const scrollTo = (node, focus = false) => {
        node?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        if (focus) node?.focus({ preventScroll: true });
      };
      const calc = () => {
        const recovery = get('recovery');
        if (!recovery) return;
        let spend = 0;
        all('[data-cost-row]').forEach(row => {
          const quantity = Math.max(0, Math.min(10000, Number(row.querySelector('[data-quantity]').value) || 0));
          const cost = Math.max(0, Math.min(100000, Number(row.querySelector('[data-cost]').value) || 0));
          spend += quantity * cost;
        });
        const share = Number(recovery.value);
        const saved = spend * share / 100;
        get('recovery-value').textContent = share + '%';
        get('monthly-saving').textContent = spend ? money(saved * 100) : '—';
        get('payback').textContent = saved > 0 ? (price / 100 / saved).toFixed(1) + ' ' + text.months : '—';
        get('calc-prompt').textContent = spend ? money(spend * 100) + ' ' + text.spend + ' × ' + share + '% ' + text.avoided : text.prompt;
      };
      const photo = key => {
        this.state.photo = key;
        const imageKey = key === 'selected' ? this.state.setup : key;
        const thumbnail = all('[data-photo]').find(button => button.dataset.photo === key);
        get('hero-image').src = thumbnail?.dataset.gallerySrc || c.images[imageKey];
        get('hero-image').alt = thumbnail?.dataset.galleryAlt || (key === 'selected' ? setupValues[this.state.setup] || c.variants[0]?.title : text[key]);
        get('photo-caption').textContent = get('hero-image').alt;
        all('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.photo === key)));
      };
      const update = (changeUrl = false) => {
        const variant = enhanced ? c.variants.find(v => v.options[0] === setupValues[this.state.setup] && v.options[1] === battery.value) : c.variants.find(v => String(v.id) === master.value);
        const displayed = variant || c.variants.find(v => v.options[0] === setupValues[this.state.setup]) || c.variants[0];
        this.state.variant = variant || null;
        price = displayed?.price ?? c.price;
        all('[data-price]').forEach(el => el.textContent = money(price));
        const compare = this.querySelector('[data-compare]');
        compare.hidden = !(displayed?.compare > price);
        compare.textContent = displayed?.compare ? money(displayed.compare) : '';
        const unavailable = enhanced && battery.value && !variant;
        get('add-button').disabled = Boolean(unavailable || (variant && !variant.available));
        get('add-button').textContent = unavailable ? text.unavailable : variant && !variant.available ? text.sold : text.add + ' — ' + money(price);
        get('selection-status').textContent = variant?.title || (setupValues[this.state.setup] || '') + ' · ' + (battery.value || text.choose);
        if (enhanced) {
          master.value = variant ? String(variant.id) : '';
          master.dispatchEvent(new Event('change', { bubbles: true }));
          get('selected-thumb').src = c.images[this.state.setup];
        }
        const terms = this.querySelector('shopify-payment-terms');
        if (variant && terms) terms.setAttribute('variant-id', String(variant.id));
        if (changeUrl && variant) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
        }
        calc();
      };
      const chooseSetup = (setup, shouldScroll) => {
        if (!enhanced) { scrollTo(get('buy')); return; }
        this.state.setup = setup;
        radios.forEach(radio => radio.checked = radio.value === setup);
        update(true);
        photo('selected');
        if (shouldScroll) { scrollTo(get('buy')); radios.find(r => r.value === setup)?.focus({ preventScroll: true }); }
      };
      if (enhanced) {
        this.querySelector('[data-enhanced-picker]').hidden = false;
        this.querySelector('[data-native-picker]').hidden = true;
        battery.required = true;
        battery.value = initial?.options[1] || '';
        radios.forEach(radio => {
          radio.checked = radio.value === this.state.setup;
          listen(radio, 'change', () => chooseSetup(radio.value, false));
        });
        listen(battery, 'change', () => update(true));
      } else {
        listen(master, 'change', () => update(true));
      }
      all('[data-select-setup]').forEach(button => listen(button, 'click', () => chooseSetup(button.dataset.selectSetup, true)));
      listen(form, 'submit', event => {
        update();
        if (!this.state.variant?.available || !form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          if (enhanced && !battery.value) battery.focus();
        }
      });
      all('[data-scroll]').forEach(link => listen(link, 'click', event => {
        const target = get(link.dataset.scroll);
        if (target) { event.preventDefault(); scrollTo(target, link.dataset.scroll === 'reviews'); }
      }));
      const badge = this.querySelector('[data-review-badge]');
      listen(badge, 'click', event => {
        event.preventDefault(); event.stopPropagation(); scrollTo(get('reviews'), true);
      }, { capture: true });
      listen(badge, 'keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault(); event.stopPropagation(); scrollTo(get('reviews'), true);
      }, { capture: true });
      all('[data-photo]').forEach(button => listen(button, 'click', () => photo(button.dataset.photo)));
      listen(get('zoom-button'), 'click', () => {
        get('zoom-image').src = get('hero-image').src;
        get('zoom-image').alt = get('hero-image').alt;
        get('image-modal').showModal();
      });
      all('[data-play]').forEach(button => listen(button, 'click', () => {
        const demo = c.demos[Number(button.dataset.play)], video = get('modal-video');
        all('video').forEach(v => v.pause());
        get('modal-video-title').textContent = demo.title;
        get('modal-video-description').textContent = demo.description || '';
        video.src = demo.src; video.poster = demo.poster;
        get('video-modal').showModal();
        video.play().catch(() => {});
      }));
      all('[data-close]').forEach(button => listen(button, 'click', () => button.closest('dialog').close()));
      all('dialog').forEach(dialog => {
        listen(dialog, 'close', () => dialog.querySelectorAll('video').forEach(video => video.pause()));
        listen(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        });
      });
      all('.calculator input').forEach(input => listen(input, 'input', calc));
      listen(get('example'), 'click', () => {
        const example = [[5,15],[4,10],[1,45],[0,50],[2,10]];
        all('[data-cost-row]').forEach((row,i) => {
          row.querySelector('[data-quantity]').value = example[i][0];
          row.querySelector('[data-cost]').value = example[i][1];
        });
        get('recovery').value = 50; calc();
      });
      listen(get('reset-calculator'), 'click', () => {
        all('.calc-table input').forEach(input => input.value = '');
        get('recovery').value = 50; calc();
      });
      const stickyCheck = () => get('sticky-buy').hidden = get('buy').getBoundingClientRect().bottom > 0;
      listen(window, 'scroll', stickyCheck, { passive: true });
      listen(window, 'resize', stickyCheck);
      update(); if (enhanced) photo('selected'); stickyCheck();
    }
    disconnectedCallback() {
      this.initializer?.disconnect();
      this.initializer = null;
      this.controller?.abort();
      this.controller = null;
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
